import { Button } from "../../components/adminDashboard/ResultsComponents"
import { FiEdit3 } from "react-icons/fi"
import { useState, useEffect } from "react"
import { userRequest } from "../../utils/requestMethods";
import { useStateContext } from "../../contexts/ContextProvider";

export default function Summary({ history }){
  const { school } = useStateContext();
  console.log(school);
  const [saveModal, setSaveModal] = useState(false);
  const [summary, setSummary] = useState({
    assessment: [],
    customization: {},
    grading: [],
    rat: {}
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [editSection, setEditSection] = useState(null); // 'ca', 'grading', 'customization', etc.
  const [editData, setEditData] = useState(null);

  const loadSummary = () => {
    const loadedSummary = JSON.parse(localStorage.getItem("summary"))
    if (loadedSummary){
      setSummary(loadedSummary)
    }
    console.log(JSON.parse(localStorage.getItem("summary")))
  }

  useEffect(() => {
    loadSummary()
  }, [])

  const submitHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    // Use new assessment.ca.cas and max_score
    const caCas = summary?.assessment?.ca?.cas || [];
    const caMaxScore = summary?.assessment?.ca?.max_score || 0;
    // Compose grading_system for request body
    const grading_system = summary?.grading?.grading_system || [];
    const requestBody = {
      assessment: {
        ca: {
          cas: caCas,
          max_score: caMaxScore,
        },
        exam: {
          max_score: 100 - caMaxScore,
        },
      },
      grading: {
        grading_system: grading_system.map(system => ({
          level_of_education: system.level_of_education,
          grades: system.grades.map(g => ({
            grade: g.grade,
            min_score: g.min_score,
            max_score: g.max_score
          })),
          is_default: !!system.is_default
        }))
      },
      remark: summary.remark || {},
      result: summary.result || {},
      term_terminology: summary.term_terminology || "Term"
    };
    try {
      await userRequest.post(`/schools/${school._id}/settings`, requestBody);
      setSuccess("Settings saved successfully!");
      setSaveModal(true);
      setTimeout(() => {
        setSuccess("");
      }, 2000);
    } catch (error) {
      console.error(error);
      setError(error?.response?.data ? error?.response?.data : "Something went wrong. Please try again.");
      setTimeout(() => setError("") , 5000);
    } finally {
      setLoading(false);
    }
  };
  
  // Handler to open modal for editing a section
  const handleEdit = (section) => {
    setEditSection(section);
    if (section === 'ca') {
      setEditData({
        cas: summary?.assessment?.ca?.cas ? JSON.parse(JSON.stringify(summary.assessment.ca.cas)) : [],
        max_score: summary?.assessment?.ca?.max_score || 0
      });
    } else if (section === 'grading') {
      setEditData(summary?.grading?.grading_system ? JSON.parse(JSON.stringify(summary.grading.grading_system)) : []);
    } else if (section === 'customization') {
      setEditData(summary?.result ? JSON.parse(JSON.stringify(summary.result)) : {});
    }
  };

  // Handler to update summary state after editing
  const handleEditSave = (section, newData) => {
    if (section === 'ca') {
      setSummary(prev => ({
        ...prev,
        assessment: {
          ...prev.assessment,
          ca: {
            ...prev.assessment.ca,
            cas: newData.cas,
            max_score: newData.max_score
          }
        }
      }));
    } else if (section === 'grading') {
      setSummary(prev => ({
        ...prev,
        grading: {
          ...prev.grading,
          grading_system: newData
        }
      }));
    } else if (section === 'customization') {
      setSummary(prev => ({
        ...prev,
        result: newData
      }));
    }
    setEditSection(null);
    setEditData(null);
  };

  return(
    <div className="m-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl dark:bg-secondary-dark-bg min-h-screen">
      <div className="flex flex-wrap gap-4 justify-between items-center">
        <h1 className="text-2xl font-extrabold tracking-tight text-slate-900 dark:text-gray-200">
          Result Setup Summary
        </h1>
        <Button onClick={submitHandler}>
          {loading ? "Saving..." : "Save and apply"}
        </Button>
      </div>
      {error && (
        <div className="p-4 my-4 text-sm text-white rounded-lg bg-red-500" role="alert">
          <span className="font-medium">Error!</span> {error}
        </div>
      )}
      {success && (
        <div className="p-4 my-4 text-sm text-white rounded-lg bg-green-500" role="alert">
          <span className="font-medium">Success!</span> {success}
        </div>
      )}
      <div className="mt-10 pt-10 border-t flex flex-wrap justify-between items-center gap-2">
        <div className="w-full max-w-2xl">
          <div className="flex justify-between gap-2 items-center">
            <p>Continous Assessment</p>
            <button className="text-red-500 hover:text-red-300 flex gap-2 items-center" onClick={() => handleEdit('ca')}>
              <FiEdit3/> Edit
            </button>
          </div>

          {summary?.assessment?.ca?.cas && Array.isArray(summary.assessment.ca.cas) && summary.assessment.ca.cas.length > 0 ? (
          <div className="bg-[#EEEEFC] mt-6 py-4 px-6 flex justify-between gap-3 rounded-xl">
            <div className="pr-4 border-r max-w-[150px] w-full">
              <p>Total Weight</p>
              <p className="font-semibold">
                {summary?.assessment?.ca?.max_score || 0}
              </p>
            </div>
            {summary.assessment.ca.cas.map((ca, idx) => (
              <div key={idx} className="max-w-[150px] w-full">
                <p className="text-[#6A69C4]">CA {ca.title || idx + 1}</p>
                <p className="font-semibold">{ca.max_score}</p>
              </div>
            ))}
          </div> 
          ) : null}
        </div>

        <div className="max-w-[200px] w-full">
          <div className="flex justify-between gap-2 items-center">
            <p>Exam Grade</p>
          </div>

          <div className="bg-[#EEEEFC] mt-6 py-4 px-6 flex gap-3 rounded-xl">
            <div className="max-w-[150px] w-full">
              <p>Total Weight</p>
              <p className="font-semibold">
                {summary?.assessment?.exam?.max_score || 0}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-10 pt-10 border-t flex flex-wrap justify-between items-center gap-2">
        <div className="w-full">
          <div className="flex justify-between gap-2 items-center">
            <p>Grading System</p>
            <button className="text-red-500 hover:text-red-300 flex gap-2 items-center" onClick={() => handleEdit('grading')}>
              <FiEdit3/> Edit
            </button>
          </div>

          <div className="bg-[#EEEEFC] mt-6 py-4 px-6 flex justify-between gap-3 rounded-xl">
            {Array.isArray(summary?.grading?.grading_system)
              ? summary.grading.grading_system.map((system, idx) => (
                  <div key={system.level_of_education || idx} className="max-w-[200px] w-full">
                    <p className="text-[#6A69C4] font-semibold mb-2 capitalize">{system.level_of_education} Grading</p>
                    {system.grades.map((grade, gidx) => (
                      <div key={grade.grade || gidx} className="mb-1">
                        <span className="font-semibold">{grade.grade}:</span> {grade.min_score} - {grade.max_score}
                      </div>
                    ))}
                    {system.is_default && <span className="text-xs text-green-600">(Default)</span>}
                  </div>
                ))
              : <span>No grading system configured.</span>}
          </div>
        </div>
      </div>

      <div className="mt-10 pt-10 border-t">
        <div className="flex justify-between gap-2 items-center">
          <p>General Customization</p>
          <button className="text-red-500 hover:text-red-300 flex gap-2 items-center" onClick={() => handleEdit('customization')}>
            <FiEdit3/> Edit
          </button>
        </div>

        <div>
          <div className="flex justify-between gap-2 my-10">
            <p className="font-semibold">Enable preview option for teachers</p>
            <p>{summary?.result?.teacher_preview ? "Yes" : "No"}</p>
          </div>
          <div className="flex justify-between gap-2 my-10">
            <p className="font-semibold">Admin must review all results</p>
            <p>{summary?.result?.admin_approval ? "Yes" : "No"}</p>
          </div>
          {/*<div className="flex justify-between gap-2 my-10">
            <p className="font-semibold">Teachers should customize result format (e.g CA weight adjustment)</p>
            <p>{summary?.result?.customize ? "Yes" : "No"}</p>
          </div>*/}
        </div>
      </div>

      {
        saveModal &&
        <div className="fixed top-0 left-0 w-full h-screen bg-[#34405480] backdrop-blur-sm flex items-center justify-center p-3" onClick={() => setSaveModal(false)}>
          <div className="bg-white max-w-md w-full rounded-3xl flex flex-col justify-center items-center gap-4 p-8">
            <img alt="check" src="/CheckCircle.svg" width={100}/>
            <p className="text-lg font-semibold my-4">Setup successful</p>
            <Button onClick={ () => history.push("/result-management")}>Proceed</Button>
          </div>
        </div>
      }

      {/* Edit Modal for CA */}
      {editSection === 'ca' && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#34405480] backdrop-blur-sm flex items-center justify-center p-3 z-50">
          <div className="bg-white max-w-md w-full rounded-3xl flex flex-col gap-4 p-8 relative">
            <button className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl" onClick={() => setEditSection(null)}>&times;</button>
            <h2 className="text-lg font-bold mb-4">Edit Continuous Assessment</h2>
            <form onSubmit={e => { e.preventDefault(); handleEditSave('ca', editData); }}>
              <div className="mb-4">
                <label className="block mb-1 font-semibold">Total Weight</label>
                <input type="number" min="0" max="100" className="w-full border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all" value={editData.max_score} onChange={e => setEditData(d => ({...d, max_score: Number(e.target.value)}))} />
              </div>
              {editData.cas.map((ca, idx) => (
                <div key={idx} className="mb-2 flex gap-2 items-center">
                  <input type="text" className="border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all flex-1" value={ca.title || ''} placeholder={`CA ${idx+1} Title`} onChange={e => {
                    const cas = [...editData.cas];
                    cas[idx].title = e.target.value;
                    setEditData(d => ({...d, cas}));
                  }} />
                  <input type="number" min="0" max={editData.max_score} className="border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all w-20" value={ca.max_score} onChange={e => {
                    const cas = [...editData.cas];
                    cas[idx].max_score = Number(e.target.value);
                    setEditData(d => ({...d, cas}));
                  }} />
                  <button type="button" className="text-red-500" onClick={() => {
                    const cas = editData.cas.filter((_, i) => i !== idx);
                    setEditData(d => ({...d, cas}));
                  }}>Remove</button>
                </div>
              ))}
              <button type="button" className="text-blue-500 mb-4" onClick={() => setEditData(d => ({...d, cas: [...d.cas, {title: '', max_score: 0}]}))}>+ Add CA</button>
              <div className="flex gap-2 mt-4">
                <Button type="submit">Save</Button>
                <Button type="button" onClick={() => setEditSection(null)} className="bg-gray-200 text-gray-700">Cancel</Button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modal for Grading System */}
      {editSection === 'grading' && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#34405480] backdrop-blur-sm flex items-center justify-center p-3 z-50">
          <div className="bg-white max-w-2xl w-full rounded-3xl flex flex-col gap-4 p-8 relative">
            <button className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl" onClick={() => setEditSection(null)}>&times;</button>
            <h2 className="text-lg font-bold mb-4">Edit Grading System</h2>
            <GradingSystemModalContent editData={editData} setEditData={setEditData} onSave={data => handleEditSave('grading', data)} onCancel={() => setEditSection(null)} />
          </div>
        </div>
      )}

      {/* Edit Modal for General Customization */}
      {editSection === 'customization' && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#34405480] backdrop-blur-sm flex items-center justify-center p-3 z-50">
          <div className="bg-white max-w-md w-full rounded-3xl flex flex-col gap-4 p-8 relative">
            <button className="absolute top-4 right-4 text-gray-400 hover:text-gray-700 text-2xl" onClick={() => setEditSection(null)}>&times;</button>
            <h2 className="text-lg font-bold mb-4">Edit General Customization</h2>
            <form onSubmit={e => { e.preventDefault(); handleEditSave('customization', editData); }}>
              <div className="mb-4 flex items-center justify-between">
                <label className="font-semibold">Enable preview option for teachers</label>
                <input type="checkbox" checked={!!editData.teacher_preview} onChange={e => setEditData(d => ({...d, teacher_preview: e.target.checked}))} />
              </div>
              <div className="mb-4 flex items-center justify-between">
                <label className="font-semibold">Admin must review all results</label>
                <input type="checkbox" checked={!!editData.admin_approval} onChange={e => setEditData(d => ({...d, admin_approval: e.target.checked}))} />
              </div>
              {/* Add more customization fields as needed */}
              <div className="flex gap-2 mt-4">
                <Button type="submit">Save</Button>
                <Button type="button" onClick={() => setEditSection(null)} className="bg-gray-200 text-gray-700">Cancel</Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

// Edit Grading System Modal Content
export function GradingSystemModalContent({ editData, setEditData, onSave, onCancel }) {
  const [selectedGradingIndex, setSelectedGradingIndex] = useState(0);
  const levels = ['primary', 'secondary'];

  // Add grading system for a level
  const handleAddGradingSystem = (level) => {
    if (!editData.some(g => g.level_of_education === level)) {
      setEditData([...editData, { level_of_education: level, grades: [], is_default: editData.length === 0 }]);
      setSelectedGradingIndex(editData.length);
    }
  };

  // Remove grading system
  const handleRemoveGradingSystem = (idx) => {
    const newData = editData.filter((_, i) => i !== idx);
    setEditData(newData);
    setSelectedGradingIndex(0);
  };

  // Set default grading system
  const handleSetDefaultGradingSystem = (idx) => {
    setEditData(editData.map((g, i) => ({ ...g, is_default: i === idx })));
  };

  // Update a grade in the selected grading system
  const handleGradingUpdate = (gradeIdx, field, value) => {
    const newData = [...editData];
    newData[selectedGradingIndex].grades[gradeIdx][field] = value;
    setEditData(newData);
  };

  // Add a grade to the selected grading system
  const handleAddGrade = () => {
    const newData = [...editData];
    newData[selectedGradingIndex].grades.push({ grade: '', min_score: 0, max_score: 0 });
    setEditData(newData);
  };

  // Remove a grade from the selected grading system
  const handleRemoveGrade = (gradeIdx) => {
    const newData = [...editData];
    newData[selectedGradingIndex].grades = newData[selectedGradingIndex].grades.filter((_, i) => i !== gradeIdx);
    setEditData(newData);
  };

  return (
    <form onSubmit={e => { e.preventDefault(); onSave(editData); }}>
      <div className="flex gap-2 mb-4 capitalize">
        {levels.map(level => (
          <button
            key={level}
            type="button"
            className={`px-3 py-1 rounded-full border capitalize ${editData.some(g => g.level_of_education === level) ? 'bg-blue-100 border-blue-500' : 'bg-gray-100 border-gray-300'}`}
            onClick={() => handleAddGradingSystem(level)}
            disabled={editData.some(g => g.level_of_education === level)}
          >
            Add {level} Grading
          </button>
        ))}
      </div>
      <div className="flex gap-2 mb-4">
        {editData.map((system, idx) => (
          <button
            key={system.level_of_education}
            type="button"
            className={`px-3 py-1 rounded-full border capitalize ${selectedGradingIndex === idx ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            onClick={() => setSelectedGradingIndex(idx)}
          >
            {system.level_of_education}
            {system.is_default && <span className="ml-2 text-xs">(Default)</span>}
          </button>
        ))}
      </div>
      <div className="flex gap-2 mb-4 flex-wrap">
        {editData.length > 1 && editData.map((system, idx) => (
          <button
            key={system.level_of_education + '-remove'}
            type="button"
            className="px-2 py-1 text-xs text-red-600 border border-red-300 rounded capitalize"
            onClick={() => handleRemoveGradingSystem(idx)}
          >
            Remove {system.level_of_education}
          </button>
        ))}
        {editData.length > 1 && editData.map((system, idx) => (
          <button
            key={system.level_of_education + '-default'}
            type="button"
            className="px-2 py-1 text-xs text-green-600 border border-green-300 rounded capitalize"
            onClick={() => handleSetDefaultGradingSystem(idx)}
            disabled={system.is_default}
          >
            Set {system.level_of_education} as Default
          </button>
        ))}
      </div>
      <div className="grid sm:grid-cols-2 gap-2 md:gap-3">
        {editData[selectedGradingIndex]?.grades.map((grade, index) => (
          <div key={index} className="flex gap-2 items-center mb-2">
            <input
              type="text"
              className="border border-gray-300 rounded-lg p-2 w-16 bg-gray-100 cursor-not-allowed"
              value={grade.grade || ''}
              placeholder="Grade"
              readOnly
              disabled
            />
            <input
              type="number"
              className="border border-gray-300 rounded-lg p-2 w-20"
              value={grade.min_score}
              placeholder="Min"
              onChange={e => handleGradingUpdate(index, 'min_score', Number(e.target.value))}
            />
            <input
              type="number"
              className="border border-gray-300 rounded-lg p-2 w-20"
              value={grade.max_score}
              placeholder="Max"
              onChange={e => handleGradingUpdate(index, 'max_score', Number(e.target.value))}
            />
            {/*<button type="button" className="text-red-500" onClick={() => handleRemoveGrade(index)}>Remove</button>*/}
          </div>
        ))}
      </div>
      {/*<button type="button" className="text-blue-500 mt-2" onClick={handleAddGrade}>+ Add Grade</button>*/}
      <div className="flex gap-2 mt-4">
        <Button type="submit">Save</Button>
        <Button type="button" onClick={onCancel} className="bg-gray-200 text-gray-700">Cancel</Button>
      </div>
    </form>
  );
}